// core/domWatcher.ts

import { applyUTMsToLinksAndForms } from "./applyUTMs";

export function observeDynamicElements({ debug = false }: { debug?: boolean }) {
  const observer = new MutationObserver(() => {
    applyUTMsToLinksAndForms({ debug });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
